import { getPortalDemographics } from 'demographics-client';
import Raven from 'raven-js';
export const fetchCompanyDetails = () => {
  return getPortalDemographics().catch(error => {
    Raven.captureException(new Error('Failed to fetch company details'), {
      extra: {
        error
      }
    });
    throw error;
  });
};